import React from 'react';

import _forEach from 'lodash/forEach';

class FilterGender extends React.Component {
    state = {
        selected: 'any',
        gender: {
            male: false,
            female: false,
            any: true
        }
    }
    onChange = (type) => {
        if (this.props.onGenderChange) {
            this.props.onGenderChange(type);
        }
    }

    onGenderApply = () => {
        const { gender } = this.state;
        let data = 'any';
        if (this.props.onGenderApply) {
            _forEach(gender, (g, k) => {
                if (g) {
                    data = k;
                }
            });
            this.props.onGenderApply(data);
        }
    }
    render() {
        return (
            <React.Fragment>
                <div className="card-body search-filter-fields">
                    <div className="scroll-window">
                        <div className="scroll-window__card">
                            <label className="search-filter-fields__item custom-checkbox" htmlFor="gender_any" name="gender">
                                <input type="checkbox" id="gender_any" name="gender" checked={this.props.selected === 'any'} className="custom-checkbox__input" onChange={(e) => {
                                    this.onChange('any', e);
                                }}/>
                                <div className="custom-checkbox__check">
                                    <i className="ion ion-md-checkmark"></i>
                                </div>
                                <div className="custom-checkbox__label">
                                    Any
                                </div>
                            </label>
                            <label className="search-filter-fields__item custom-checkbox" htmlFor="gender_male" name="gender">
                                <input type="checkbox" id="gender_male" name="gender" checked={this.props.selected === 'male'} className="custom-checkbox__input"  onChange={(e) => {
                                    this.onChange('male', e);
                                }}/>
                                <div className="custom-checkbox__check">
                                    <i className="ion ion-md-checkmark"></i>
                                </div>
                                <div className="custom-checkbox__label">
                                    Male
                                </div>
                            </label>
                            <label className="search-filter-fields__item custom-checkbox" htmlFor="gender_female" name="gender">
                                <input type="checkbox" id="gender_female" name="gender" className="custom-checkbox__input" checked={this.props.selected === 'female'} onChange={(e) => {
                                    this.onChange('female', e);
                                }}/>
                                <div className="custom-checkbox__check">
                                    <i className="ion ion-md-checkmark"></i>
                                </div>
                                <div className="custom-checkbox__label">
                                    Female
                                </div>
                            </label>
                        </div>
                    </div>    
                </div>
                <div className="card-footer" style={{ marginBottom: `${+this.props.headerHeight}px`}}>
                    <div onClick={() => {
                        this.onGenderApply();
                    }} className="btn btn-green btn-footer"
                    >Apply</div>
                </div>
            </React.Fragment>
        );
    }
}

export default FilterGender;